// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#204b6e"};